import React from 'react'
import { FormattedMessage } from "react-intl";
import { Button, Typography } from '../common';
import { imageBaseURL } from '../../utils/imageBaseUrl';
import { useNavigate } from 'react-router-dom';

class ErrorBoundaryComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { errorInfo: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
    }

    handleNavigatetoPrev() {
        this.props.navigate(-1)
    }
    handleRefresh() {
        window.location.reload()
    }


    render() {
        if (this.state.errorInfo) {
            return (<div className="flex h-screen text-center items-center justify-center mx-8">
                <div className="flex flex-col justify-center">
                    <Typography variant="lg" className="font-semibold text-black mt-2 flex items-center justify-center m-auto mb-5" text={<FormattedMessage id="REACT.APP.ERROR.MESSAGE" />} />
                    <div className='h-24 w-24 m-auto'>
                        <img alt="error" className='h-full w-full object-cover' src={`${imageBaseURL}/images/error.png`} />
                    </div>
                    <div className='w-1/2 m-auto mt-4 bg-white h-[100vh] overflow-y-auto flex flex-col gap-2 border border-secondary-50 rounded-md p-3'>
                        <Typography variant="sm" className="text-secondary-500 font-bold" text={this.state.error && this.state.error?.toString()} />
                        <Typography variant="sm" className="font-thin text-[9.5px] text-left" text={this.state.errorInfo.componentStack} />
                    </div>
                    <div className='m-auto flex  items-center gap-2'>
                        <Button variant="primary" className="w-fit m-auto" onClick={() => this.handleNavigatetoPrev()} text="Go Back" />
                        <Button variant="secondary" className="w-fit m-auto" onClick={() => this.handleNavigatetoPrev()} text="Refresh" />
                    </div>
                </div>
            </div>)
        }

        return this?.props?.children;
    }
}

const ErrorBoundary = (props) => {
    const navigate = useNavigate()
    return <ErrorBoundaryComponent navigate={navigate} {...props} >{props?.children}</ErrorBoundaryComponent>
}

export default ErrorBoundary;

